
define('text!templates/components/reseller_product_compact/reseller_product.html',[],function () { return '<td data-cell="name">\n    <a href="/licenses/<%= id %>"><%= product.name %></a>\n</td>\n\n<td data-cell="count">\n    <%= count %>\n</td>\n';});

